import React from 'react';
import "./_articleSeo.scss";
export const ArticleSeo = ({title_1,title_2,text_1,text_2,text_3,text_4,list_1,list_2}) => {
  return (
    <div className='container-grid'>
    <article className='article'>
      <h2 className='article__h3'> {title_1}</h2>
      <p className='article__text'>
        {text_1}</p>
      <p className='article__text'>
      {text_2}
      </p>
      </article>
      <article className='article'>
      <h2 className='article__h3'>{title_2}</h2>
      <p className='article__text'>
      {text_3}
      </p>
      <ul className='article__ul'>
        <li className='article__text'>{list_1}</li>
        <li className='article__text'>{list_2}</li>
      </ul>
      <p className='article__text'>
      {text_4}
      </p>
      </article>
      </div>
  );
};

